export const PAYMENT_PREFIX = '__horus_payment__';
export const PAYMENT_REQUEST_PREFIX = '__horus_payment_request__';

export interface PaymentMessagePayload {
  version: 1;
  txHash: string;
  chain: string;
  chainId: number;
  tokenSymbol: string;
  tokenAddress: string;
  amount: string;
  decimals: number;
  senderAddress: string;
  recipientAddress: string;
  status: 'confirmed';
  timestamp: number;
}

export interface PaymentRequestPayload {
  version: 1;
  chain: string;
  chainId: number;
  tokenSymbol: string;
  tokenAddress: string;
  amount: string;
  decimals: number;
  requesterAddress: string;
  note?: string;
  timestamp: number;
}

export function isPaymentMessage(text: string): boolean {
  return typeof text === 'string' && text.startsWith(PAYMENT_PREFIX);
}

export function isPaymentRequest(text: string): boolean {
  return typeof text === 'string' && text.startsWith(PAYMENT_REQUEST_PREFIX);
}

export function parsePaymentMessage(text: string): PaymentMessagePayload | null {
  try {
    return JSON.parse(text.slice(PAYMENT_PREFIX.length));
  } catch {
    return null;
  }
}

export function parsePaymentRequest(text: string): PaymentRequestPayload | null {
  try {
    return JSON.parse(text.slice(PAYMENT_REQUEST_PREFIX.length));
  } catch {
    return null;
  }
}

export function encodePaymentMessage(payload: PaymentMessagePayload): string {
  return PAYMENT_PREFIX + JSON.stringify(payload);
}

export function encodePaymentRequest(payload: PaymentRequestPayload): string {
  return PAYMENT_REQUEST_PREFIX + JSON.stringify(payload);
}
